// extracted by mini-css-extract-plugin
module.exports = {"allPinsBoard":"qpoc2xUZ","cover":"B7HGytNU","coverContainer":"va0rjO0u","img":"h7pZjkmE","imgWrap":"fahhXO9E","emptyImg":"__4FSB6iiM","title":"ruIOqMDy","info":"fhSsbx3T"};